import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import { dashboard, dashboardactive, operation, operationactive, setting, settingactive, marketing, mission, marketingactive, missionactive, cms, cmsactive, reportactive, report, user, useractive, team, teamactive, payment, paymentactive,logo,community } from "../../assets/Exportimageicon";



const AdminSidebar = ({ collapsed }) => {
    const [isHover, setIsHover] = useState(false);
    const isExpanded = !collapsed || isHover;
    return (
        <div
            className={`sidebar ${collapsed ? "collapsed" : ""} ${isHover ? "hover-open" : ""}`}
            onMouseEnter={() => collapsed && setIsHover(true)}
            onMouseLeave={() => { if (collapsed) setIsHover(false); }}
        >
            <div class="logo">
                <img src={logo} alt="Logo" class="logo-img" />

            </div>
            {/* <div className="welcomemsg">Welcome John <img src={hand} alt="" /></div> */}

            <ul className="menu">

                <li className="menu-item">
                    <NavLink to="/dashboard" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? dashboardactive : dashboard} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Dashboard</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/missions" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? missionactive : mission} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Manage Missions</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/users" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? useractive : user} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Users</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/teams" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? teamactive : team} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Teams</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/payment" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? paymentactive : payment} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Payments</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/marketing" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? marketingactive : marketing} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Marketing</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/cms" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? cmsactive : cms} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">CMS</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/report" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? reportactive : report} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Reports & Analytics</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/more-info" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? reportactive : report} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Information Center</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                <li className="menu-item">
                    <NavLink to="/support" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? operationactive : operation} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Support & Operations</span>}
                            </>
                        )}
                    </NavLink>
                </li>

                {/* <li className="menu-item">
                    <NavLink to="/setting" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? settingactive : setting} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Settings</span>}
                            </>
                        )}
                    </NavLink>
                </li> */}

                 <li className="menu-item">
                    <NavLink to="/community" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
                        {({ isActive }) => (
                            <>
                                <img src={isActive ? community : community} className="menu-icon-img" alt="" />
                                {isExpanded && <span className="menu-text">Community</span>}
                            </>
                        )}
                    </NavLink>
                </li>

            </ul>
        </div>
    );
};

export default AdminSidebar;